<template>
  <div id="pest-real" style="overflow:hidden;">
    <div class="pestReal-data">
      <div class="pestReal-data-head">
        <div class="pestReal-head-left">
          <span class="pestReal-left-title">虫情实时数据</span>
        </div>
        <div class="pestReal-head-right">
          <div class="pestReal-right-select">
            设备名
            <el-select @change="pestRealChange($event)" v-model="pestDevice" filterable>
              <el-option :key="item.deviceAddr" :label="item.deviceName" :value="item.deviceAddr" v-for="item in pestOption"></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="pestReal-data-content" style="overflow:auto;">
        <div class="pestReal-content-top">
          <div class="pestReal-top-container">
            <div class="pestReal-top-img">
              <div class="pest-top-img-container">
                <img src="../img/deviceName.png">
              </div>
            </div>
            <div class="pestReal-top-name">
              <div class="pestReal-top-name-container">
                <span>设备名称</span><br/><span>{{pestDeviceName}}</span>
              </div>
            </div>
          </div>

          <div class="pestReal-top-container">
            <div class="pestReal-top-img" >
              <div class="pest-top-img-container">
                <img src="../img/deviceAddr.png">
              </div>
            </div>
            <div class="pestReal-top-name">
              <div class="pestReal-top-name-container">
                <span>设备地址</span><br/><span>{{pestDeviceAddr}}</span>
              </div>
            </div>
          </div>

          <div class="pestReal-top-container" >
            <div class="pestReal-top-img">
              <div class="pest-top-img-container">
                <img src="../img/deviceState.png">
              </div>
            </div>
            <div class="pestReal-top-name">
              <div class="pestReal-top-name-container" >
                <span>设备状态</span><br/><span>{{pestStatus}}</span>
              </div>
            </div>
          </div>

          <div class="pestReal-top-container">
            <div class="pestReal-top-img" >
              <div class="pest-top-img-container">
                <img src="../img/deviceType.png">
              </div>
            </div>
            <div class="pestReal-top-name" >
              <div class="pestReal-top-name-container" >
                <span>设备类型</span><br/><span>{{pestType}}</span>
              </div>
            </div>
          </div>

          <div class="pestReal-top-container" >
            <div class="pestReal-top-img">
              <div class="pest-top-img-container" >
                <img src="../img/deviceSave.png">
              </div>
            </div>
            <div class="pestReal-top-name" >
              <div class="pestReal-top-name-container">
                <span>数据保存间隔</span><br/><span>{{pestSaveInterval}}分钟</span>
              </div>
            </div>
          </div>
        </div>

        <div class="pestReal-content-middle">
          <div class="pestReal-middle-title" :style="pestRadio != '' ? '' : 'pointer-events: none; '">
            <div class="pestReal-title-name">
              <span class="pestReal-title-name-container">运行模式</span>
            </div>
            <div class="pestReal-title-value" >
              <el-radio-group @change="pestModel" v-model="pestRadio" class="pestReal-title-value-container">
                <el-radio-button label="0">手动</el-radio-button>
                <el-radio-button label="1">自动</el-radio-button>
              </el-radio-group>
            </div>
          </div>

          <div class="pestReal-middle-body">
            <div class="pestReal-body-hand" :style="pestRadio == '0' ? '' : 'pointer-events: none;'">
              <dv-border-box12>
                <div class="pestReal-hand-name">
                  <span class="pestReal-hand-name-container">手动模式</span>
                </div>
                <div class="pestReal-hand-content">
                  <div class="pestReal-hand-basic">
                    <div class="pestReal-hand-top-piece" style="margin-left: 23%;">
                      <div class="pestReal-hand-top-name">
                        <span class="pestReal-hand-top-nameContainer">诱虫灯</span>
                      </div>
                      <div class="pestReal-hand-top-value">
                        <span class="pestReal-hand-top-valueContainer" @click="setAttractWorm">{{pestAttractWorm}}</span>
                      </div>
                    </div>

                    <div class="pestReal-hand-top-piece" style="margin-left: 6%">
                      <div class="pestReal-hand-top-name" >
                        <span  class="pestReal-hand-top-nameContainer">补光灯</span>
                      </div>
                      <div class="pestReal-hand-top-value">
                        <span class="pestReal-hand-top-valueContainer" @click="setFillLight">{{pestFillLight}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="pestReal-hand-basic" style=" margin-top: 2%;">
                    <div class="pestReal-hand-top-piece" style="margin-left: 23%">
                      <div class="pestReal-hand-top-name">
                        <span class="pestReal-hand-top-nameContainer">震动装置</span>
                      </div>
                      <div class="pestReal-hand-top-value" >
                        <span class="pestReal-hand-top-valueContainer" @click="setShake">{{pestShake}}</span>
                      </div>
                    </div>

                    <div class="pestReal-hand-top-piece" style="margin-left: 6%">
                      <div class="pestReal-hand-top-name">
                        <span class="pestReal-hand-top-nameContainer">摄像头</span>
                      </div>
                      <div class="pestReal-hand-top-value">
                        <span class="pestReal-hand-top-valueContainer" @click="setCamera">拍摄</span>
                      </div>
                    </div>
                  </div>

                  <div class="pestReal-hand-basic" style="margin-top: 2%;">
                    <div class="pestReal-hand-bottom-piece">
                      <div class="pestReal-hand-bottom-name" >
                        <span class="pestReal-hand-bottom-nameContainer">杀虫控制</span>
                      </div>
                      <div class="pestReal-hand-bottom-value">
                        <span class="pestReal-hand-bottom-valueContainer" @click="setInsecticide">{{pestInsecticide}}</span>
                      </div>
                    </div>

                    <div class="pestReal-hand-bottom-piece">
                      <div class="pestReal-hand-bottom-name">
                        <span class="pestReal-hand-bottom-nameContainer">杀虫挡板</span>
                      </div>
                      <div class="pestReal-hand-bottom-value">
                        <span class="pestReal-hand-bottom-valueContainer" @click="setWormFlap">{{pestWormFlap}}</span>
                      </div>
                    </div>

                    <div class="pestReal-hand-bottom-piece">
                      <div class="pestReal-hand-bottom-name">
                        <span class="pestReal-hand-bottom-nameContainer">虫雨挡板</span>
                      </div>
                      <div class="pestReal-hand-bottom-value">
                        <span class="pestReal-hand-bottom-valueContainer" @click="setRainFlap">{{pestRainFlap}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="pestReal-hand-basic" style="margin-top: 2%;">
                    <div class="pestReal-hand-bottom-piece">
                      <div class="pestReal-hand-bottom-name">
                        <span class="pestReal-hand-bottom-nameContainer"> 烘干控制</span>
                      </div>
                      <div class="pestReal-hand-bottom-value" >
                        <span class="pestReal-hand-bottom-valueContainer" @click="setDrying">{{pestDrying}}</span>
                      </div>
                    </div>

                    <div class="pestReal-hand-bottom-piece" >
                      <div class="pestReal-hand-bottom-name">
                        <span class="pestReal-hand-bottom-nameContainer" >烘干挡板</span>
                      </div>
                      <div class="pestReal-hand-bottom-value">
                        <span class="pestReal-hand-bottom-valueContainer" @click="setDryingFlap">{{pestDryingFlap}}</span>
                      </div>
                    </div>

                    <div class="pestReal-hand-bottom-piece">
                      <div class="pestReal-hand-bottom-name">
                        <span class="pestReal-hand-bottom-nameContainer">移虫装置</span>
                      </div>
                      <div class="pestReal-hand-bottom-value">
                        <span class="pestReal-hand-bottom-valueContainer" @click="setMoveWorm">{{pestMoveWorm}}</span>
                      </div>
                    </div>

                  </div>
                </div>
              </dv-border-box12>
            </div>

            <div class="pestReal-body-auto" :style="pestRadio == '1' ? '' : 'pointer-events: none; '">
              <dv-border-box12>
                <div class="pestReal-auto-name">
                  <span class="pestReal-auto-name-container">自动模式</span>
                </div>

                <div class="pestReal-auto-content">
                  <div class="pest-auto-basic">
                    <div class="pestReal-auto-top-piece">
                      <div class="pestReal-auto-top-name">
                        <span class="pestReal-auto-top-nameContainer">开始时间</span>
                      </div>
                      <div class="pestReal-auto-top-value">
                        <el-input v-model="pestBeginTime" placeholder="08:00:00" class="pestReal-auto-top-valueContainer"/>
                      </div>
                    </div>

                    <div  class="pestReal-auto-top-piece">
                      <div class="pestReal-auto-top-name">
                        <span class="pestReal-auto-top-nameContainer">工作时长(H)</span>
                      </div>
                      <div class="pestReal-auto-top-value">
                        <el-input v-model="pestRunHour" placeholder="0" class="pestReal-auto-top-valueContainer"/>
                      </div>
                    </div>

                    <div  class="pestReal-auto-top-piece">
                      <div class="pestReal-auto-top-name">
                        <span class="pestReal-auto-top-nameContainer">引虫时长(M)</span>
                      </div>
                      <div class="pestReal-auto-top-value">
                        <el-input v-model="pestAttractWormTime" placeholder="0"  class="pestReal-auto-top-valueContainer"/>
                      </div>
                    </div>
                  </div>

                  <div class="pest-auto-basic" style="margin-top: 2%;">
                    <div class="pestReal-auto-centre-piece" style="margin-left: 23%">
                      <div class="pestReal-auto-centre-name">
                        <span class="pestReal-auto-centre-nameContainer">杀虫温度</span>
                      </div>
                      <div class="pestReal-auto-centre-value">
                        <el-input v-model="pestInsecticideHum" placeholder="0.0" class="pestReal-auto-centre-valueContainer"/>
                      </div>
                    </div>

                    <div class="pestReal-auto-centre-piece" style=" margin-left: 6%">
                      <div class="pestReal-auto-centre-name">
                        <span class="pestReal-auto-centre-nameContainer">杀虫温度回差</span>
                      </div>
                      <div class="pestReal-auto-centre-value">
                        <el-input v-model="pestInsecticideHumHystersis" placeholder="0.0" class="pestReal-auto-centre-valueContainer"/>
                      </div>
                    </div>
                  </div>

                  <div class="pest-auto-basic" style=" margin-top: 2%;">
                    <div class="pestReal-auto-centre-piece" style="margin-left: 23%">
                      <div class="pestReal-auto-centre-name">
                        <span class="pestReal-auto-centre-nameContainer">烘干温度</span>
                      </div>
                      <div  class="pestReal-auto-centre-value">
                        <el-input v-model="pestDryingHum" placeholder="0.0" class="pestReal-auto-centre-valueContainer"/>
                      </div>
                    </div>

                    <div class="pestReal-auto-centre-piece" style="margin-left: 6%">
                      <div class="pestReal-auto-centre-name">
                        <span class="pestReal-auto-centre-nameContainer">烘干温度回差</span>
                      </div>
                      <div class="pestReal-auto-centre-value">
                        <el-input v-model="pestDryingHumHystersis" placeholder="0.0" class="pestReal-auto-centre-valueContainer"/>
                      </div>
                    </div>
                  </div>

                  <div  class="pest-auto-basic" style="margin-top: 2%;">
                    <div class="pestReal-auto-bottom-piece" style="margin-left: 18%">
                      <div class="pestReal-auto-bottom-name">
                        <span class="pestReal-auto-bottom-nameContainer">雨后延迟工作时间(M)</span>
                      </div>
                      <div class="pestReal-auto-bottom-value">
                        <el-input v-model="pestDelayAfterRain" placeholder="0" class="pestReal-auto-bottom-valueContainer"/>
                      </div>
                    </div>

                    <div class="pestReal-auto-bottom-piece" style="margin-left: 6%">
                      <div class="pestReal-auto-bottom-name">
                        <span class="pestReal-auto-bottom-nameContainer">诱虫灯开启时长(M)</span>
                      </div>
                      <div class="pestReal-auto-bottom-value">
                        <el-input v-model="pestOpeningTimeOfTrapLamp" placeholder="0" class="pestReal-auto-bottom-valueContainer"/>
                      </div>
                    </div>

                    <div class="pestReal-auto-bottom-btn">
                      <el-button type="primary" plain style="position: absolute; bottom: 0%;" @click="setWormAutoMode">修改</el-button>
                    </div>
                  </div>
                </div>
              </dv-border-box12>
            </div>
          </div>
        </div>

        <div class="pestReal-content-bottom">
          <div class="pestReal-bottom-container">
            <div class="pestReal-bottom-img">
              <div class="pestReal-bottom-img-container">
                <img src="../img/pestWea.png">
              </div>
            </div>
            <div class="pestReal-bottom-name">
              <div class="pestReal-bottom-name-container">
                <span>降雨量</span><br/><span>{{pestRain}}mm</span>
              </div>
            </div>
          </div>

          <div class="pestReal-bottom-container">
            <div class="pestReal-bottom-img">
              <div class="pestReal-bottom-img-container">
                <img src="../img/pestSun.png">
              </div>
            </div>
            <div class="pestReal-bottom-name">
              <div class="pestReal-bottom-name-container">
                <span>光照度</span><br/><span>{{pestIllum}}Lux</span>
              </div>
            </div>
          </div>

          <div class="pestReal-bottom-container">
            <div class="pestReal-bottom-img">
              <div class="pestReal-bottom-img-container">
                <img src="../img/pestSoilTem.png">
              </div>
            </div>
            <div class="pestReal-bottom-name" >
              <div class="pestReal-bottom-name-container">
                <span>杀虫仓温度</span><br/><span>{{pestInsecticideTem}}℃</span>
              </div>
            </div>
          </div>

          <div class="pestReal-bottom-container">
            <div class="pestReal-bottom-img">
              <div class="pestReal-bottom-img-container">
                <img src="../img/pestDryTem.png">
              </div>
            </div>
            <div class="pestReal-bottom-name">
              <div  class="pestReal-bottom-name-container">
                <span>烘干仓温度</span><br/><span>{{pestDryingTem}}℃</span>
              </div>
            </div>
          </div>

          <div class="pestReal-bottom-container">
            <div class="pestReal-bottom-img">
              <div class="pestReal-bottom-img-container">
                <img src="../img/deviceOff.png">
              </div>
            </div>
            <div class="pestReal-bottom-name">
              <div class="pestReal-bottom-name-container">
                <span>离线判断间隔</span><br/><span>{{pestOffInterval}}分钟</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SporeAnalyseData from "./SporeAnalyseData";
  import {bathDeviceDo, modWormAutoMode, wormAutoMode, wormMode, wormOper} from "../../until/api/SporePest";
  export default {
    name: 'PestRealData',
    components: {SporeAnalyseData},
    data() {
      return {
        pestOption:[],
        pestDevice: '',
        pestDeviceName: '-',
        pestDeviceAddr: '-',
        pestStatus: '-',
        pestType: '-',
        pestSaveInterval: '-',
        pestRain: '-',
        pestIllum: '-',
        pestInsecticideTem: '-',
        pestDryingTem: '-',
        pestOffInterval: '-',
        pestRadio: '',
        pestAttractWorm: '-',
        pestFillLight: '-',
        pestShake: '-',
        pestInsecticide: '-',
        pestWormFlap: '-',
        pestRainFlap: '-',
        pestDrying: '-',
        pestDryingFlap: '-',
        pestMoveWorm: '-',
        pestBeginTime:'',
        pestRunHour: 0,
        pestAttractWormTime: 0,
        pestInsecticideHum: 0.0,
        pestInsecticideHumHystersis: 0.0,
        pestDryingHum: 0.0,
        pestDryingHumHystersis: 0.0,
        pestDelayAfterRain: 0,
        pestOpeningTimeOfTrapLamp: 0,
        pestTime: null,
      }
    },

    mounted() {
      this.pestDeviceList(); //获取虫情设备列表
    },

    beforeDestroy() {
      //关闭画面时 时间清空
      clearInterval(this.pestTime);
      this.pestTime = null;
    },

    methods: {
      /**
       * 获取虫情设备列表
       */
      pestDeviceList() {
        let that = this;
        this.$SporeSoilCommon.getSpDeviceList(function (deviceList) { //获取所有虫情孢子设备
          if(deviceList.code != 2000) {
            for(let i = 0; i < deviceList.data.length; i++) {
              if(deviceList.data[i].deviceType.indexOf('worm') > -1) {//筛选出虫情设备
                let pestJson = {};
                pestJson.deviceAddr = deviceList.data[i].deviceAddr;
                pestJson.deviceName = deviceList.data[i].deviceName;
                that.pestOption.push(pestJson);
              }
            }
            if(that.pestOption.length > 0) {
              that.pestDevice = that.pestOption[0].deviceAddr; //默认虫情设备id
              that.pestRealDataTime(); //获取设备实时数据
            }
          }
        })
      },

      /**
       * 切换设备
       * @param event
       */
      pestRealChange(event) {
        this.pestDevice = event;
        clearInterval(this.pestTime);
        this.pestTime = null;
        this.pestRealDataTime();//获取设备实时数据
      },

      /**
       * 获取设备实时数据
       */
      pestRealDataTime() {
        let that = this;
        this.$SporeSoilCommon.spRealDataTime(this.pestDevice, function (pestList) {
          that.setPestRealData(pestList);
        });

        //每隔一分钟获取一次实时数据
        this.pestTime = window.setInterval(() => {
          setTimeout(() =>{
            this.$SporeSoilCommon.spRealDataTime(this.pestDevice, function (pestList) {
              that.setPestRealData(pestList);
            })
          }, 0)
        }, 1000 * 60)
      },

      /**
       * 画面设置填充数据
       * @param pestList
       */
      setPestRealData(pestList) {
        if(pestList.data.length == 0) {
          this.pestDeviceName = '-'; //设备名
          this.pestDeviceAddr = '-'; //设备地址
          this.pestStatus = '-'; //设备状态
          this.pestType = '-'; //设备类型
          this.pestRain = '-'; //降雨状态
          this.pestIllum = '-'; //光照度
          this.pestInsecticideTem = '-'; //杀虫仓温度
          this.pestDryingTem = '-';  //烘干仓温度
          this.pestSaveInterval = '-'; //数据保存间隔
          this.pestOffInterval = '-'; //离线判断间隔

          this.pestRadio = ''; //设置模式

          this.pestAttractWorm = '-'; //诱虫灯状态
          this.pestFillLight = '-'; //补光灯状态
          this.pestShake = '-'; // 震动装置状态
          this.pestInsecticide = '-'; //杀虫控制状态
          this.pestWormFlap = '-';//杀虫挡板状态
          this.pestRainFlap = '-';//虫雨挡板状态
          this.pestDrying = '-'; //烘干控制状态
          this.pestDryingFlap = '-'; //烘干挡板状态
          this.pestMoveWorm = '-';//移虫装置状态

          this.pestBeginTime = ''; //开始时间
          this.pestRunHour = 0; //工作时长
          this.pestAttractWormTime = 0;//引虫时长
          this.pestInsecticideHum = 0.0;//杀虫温度
          this.pestInsecticideHumHystersis = 0.0;//杀虫温度回差
          this.pestDryingHum = 0.0; //烘干温度
          this.pestDryingHumHystersis = 0.0; //烘干温度回差
          this.pestDelayAfterRain = 0; //雨后延迟工作时间
          this.pestOpeningTimeOfTrapLamp = 0;//诱虫灯开启时长

          return;
        }
        //上下共同属性状态
        this.pestDeviceName = pestList.data[0].deviceName; //设备名
        this.pestDeviceAddr = pestList.data[0].deviceAddr; //设备地址
        this.pestStatus = pestList.data[0].status == 'online' ? '在线' : '离线'; //设备状态
        this.pestType = '虫情'; //设备类型
        this.pestRain = pestList.data[0].data.rain; //降雨状态
        this.pestIllum = pestList.data[0].data.illum; //光照度
        this.pestInsecticideTem = pestList.data[0].data.insecticideTem; //杀虫仓温度
        this.pestDryingTem = pestList.data[0].data.dryingTem; //烘干仓温度
        this.getPestDevice(); //获取数据保存间隔和离线判断间隔

        //模式获取
        this.pestRadio = pestList.data[0].data.mode;

        //手动模式
        this.pestAttractWorm = pestList.data[0].data.attractWorm == '0' ? '关闭' : '打开'; //诱虫灯状态
        this.pestFillLight = pestList.data[0].data.fillLight == '0' ? '关闭' : '打开'; //补光灯状态
        this.pestShake = pestList.data[0].data.shake == '0' ? '关闭' : '打开'; // 震动装置状态
        this.pestInsecticide = pestList.data[0].data.insecticide == '0' ? '关闭' : '打开'; //杀虫控制状态
        this.pestWormFlap = pestList.data[0].data.wormFlap == '0' ? '关闭' : '打开';//杀虫挡板状态
        this.pestRainFlap = pestList.data[0].data.rainFlap == '0' ? '关闭' : '打开';//虫雨挡板状态
        this.pestDrying = pestList.data[0].data.drying == '0' ? '关闭' : '打开'; //烘干控制状态
        this.pestDryingFlap = pestList.data[0].data.dryingFlap == '0' ? '关闭' : '打开'; //烘干挡板状态
        this.pestMoveWorm = pestList.data[0].data.moveWorm == '0' ? '关闭' : '打开';//移虫装置状态

        //自动模式
        this.getPestAutoModel();
      },

      /**
       * 获取数据保存间隔和离线判断间隔
       */
      getPestDevice() {
        bathDeviceDo(this.pestDevice).then(response => {
          this.pestSaveInterval = response.data.data[0].saveDateInterval; //数据保存间隔
          this.pestOffInterval = response.data.data[0].offlineInterval; //离线判断间隔
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取自动模式下的数据
       */
      getPestAutoModel() {
        wormAutoMode(this.pestDevice).then(response => {
          this.pestBeginTime = response.data.data.beginTime; //开始时间
          this.pestRunHour = response.data.data.runHour; //工作时长
          this.pestAttractWormTime = response.data.data.attractWormTime;//引虫时长
          this.pestInsecticideHum = response.data.data.insecticideHum;//杀虫温度
          this.pestInsecticideHumHystersis = response.data.data.insecticideHumHystersis;//杀虫温度回差
          this.pestDryingHum = response.data.data.dryingHum; //烘干温度
          this.pestDryingHumHystersis = response.data.data.dryingHumHystersis; //烘干温度回差
          this.pestDelayAfterRain = response.data.data.delayAfterRain; //雨后延迟工作时间
          this.pestOpeningTimeOfTrapLamp = response.data.data.openingTimeOfTrapLamp;//诱虫灯开启时长
        }).catch(error => {
          console.log("error", error);
        })
      },

      /**
       *切换运行模式
       * @param e
       */
      pestModel(e) {
        this.pestRadio = e;
        this.$confirm('请确定是否更改运行模式', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.pestRadio = e;
          let pestRadioName = this.pestRadio == '0' ? '手动' : '自动';
          let param = {"deviceAddr": this.pestDevice, "mode": this.pestRadio};
          console.log("运行模式更改：", param);
          wormMode(param).then(response => {
            this.$message({
              showClose: true,
              type: 'success',
              message: pestRadioName + '运行模式切换成功'
            })
          }).catch(error => {
            this.pestRadio = e == '1' ? '0' : '1';
            this.$message({
              showClose: true,
              type: 'warning',
              message: '运行模式切换失败'
            })
          })
        }).catch(() => {
          this.pestRadio = e == '1' ? '0' : '1';
          this.$message({
            showClose: true,
            type: 'warning',
            message: '运行模式切换已取消'
          })
        })
      },

      /**
       * 更改诱虫灯状态
       */
      setAttractWorm() {
        this.$confirm('请确定是否更改诱虫灯状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let opt = this.pestAttractWorm == '关闭' ? '1' : '0';
          let param = {"deviceAddr": this.pestDevice, "module": "attractWorm", "opt": opt};
          console.log("更改诱虫灯状态", param);
          wormOper(param).then(response => {
            this.pestAttractWorm = this.pestAttractWorm == '关闭' ? '打开' : '关闭';
            this.$message({
              showClose: true,
              type: 'success',
              message: '诱虫灯' + this.pestAttractWorm + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改诱光灯状态失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改诱光灯状态已取消'
          })
        })
      },

      /**
       * 更改补光灯状态
       */
      setFillLight() {
        this.$confirm('请确定是否更改补光灯状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let opt = this.pestFillLight == '关闭' ? '1' : '0';
          let param = {"deviceAddr": this.pestDevice, "module": "fillLight", "opt": opt};
          console.log("更改补光灯状态", param);
          wormOper(param).then(response => {
            this.pestFillLight = this.pestFillLight == '关闭' ? '打开' : '关闭';
            this.$message({
              showClose: true,
              type: 'success',
              message: '补光灯' + this.pestFillLight + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改补光灯状态失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改补光灯状态已取消'
          })
        })
      },

      /**
       * 更改震动装置状态
       */
      setShake() {
        this.$confirm('请确定是否要更改震动装置状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let opt = this.pestShake == '关闭' ? '1' : '0';
          let param = {"deviceAddr": this.pestDevice, "module": "shake", "opt": opt};
          console.log("更改震动装置", param);
          wormOper(param).then(response => {
            this.pestShake = this.pestShake == '关闭' ? '打开' : '关闭';
            this.$message({
              showClose: true,
              type: 'success',
              message: '震动装置' + this.pestShake + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改震动装置状态失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改震动装置状态已取消'
          })
        })
      },

      /**
       * 更改杀虫控制状态
       */
      setInsecticide() {
        this.$confirm('请确定是否更改杀虫控制状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let opt = this.pestInsecticide == '关闭' ? '1' : '0';
          let param = {"deviceAddr": this.pestDevice, "module": "insecticide", "opt": opt};
          console.log("更改杀虫状态控制", param);
          wormOper(param).then(response => {
            this.pestInsecticide = this.pestInsecticide == '关闭' ? '打开' : '关闭';
            this.$message({
              showClose: true,
              type: 'success',
              message: '杀虫控制' + this.pestInsecticide + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改杀虫状态失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改杀虫控制状态已取消'
          })
        })
      },

      /**
       * 更改杀虫挡板状态
       */
      setWormFlap() {
        this.$confirm('请确定是否更改杀虫挡板状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let opt = this.pestWormFlap == '关闭' ? '1' : '0';
          let param = {"deviceAddr": this.pestDevice, "module": "wormFlap", "opt": opt};
          console.log("更改杀虫挡板状态", param);
          wormOper(param).then(response => {
            this.pestWormFlap = this.pestWormFlap == '关闭' ? '打开' : '关闭';
            this.$message({
              showClose: true,
              type: 'success',
              message: '杀虫挡板' + this.pestWormFlap + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改杀虫挡板状态失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改杀虫挡板状态已取消'
          })
        })
      },

      /**
       * 更改虫雨挡板状态
       */
      setRainFlap() {
        this.$confirm('请确定是否更改虫雨挡板状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let opt = this.pestRainFlap == '关闭' ? '1' : '0';
          let param = {"deviceAddr": this.pestDevice, "module": "rainFlap", "opt": opt};
          console.log("更改虫雨挡板状态", param);
          wormOper(param).then(response => {
            this.pestRainFlap = this.pestRainFlap == '关闭' ? '打开' : '关闭';
            this.$message({
              showClose: true,
              type: 'success',
              message: '虫雨挡板' + this.pestRainFlap + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改虫雨挡板状态失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改虫雨挡板状态已取消'
          })
        })
      },

      /**
       * 更改烘干控制状态
       */
      setDrying() {
        this.$confirm('请确定是否更改烘干控制状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          let opt = this.pestDrying == '关闭' ? '1' : '0';
          let param = {"deviceAddr": this.pestDevice, "module": "drying", "opt": opt};
          console.log("更改烘干控制状态", param);
          wormOper(param).then(response => {
            this.pestDrying  = this.pestDrying == '关闭' ? '打开' : '关闭';
            this.$message({
              showClose: true,
              type: 'success',
              message: '烘干控制' + this.pestDrying + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改烘干控制状态失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改烘干控制状态已取消'
          })
        })
      },

      /**
       * 更改烘干挡板状态
       */
      setDryingFlap() {
        this.$confirm('请确定是否更改烘干挡板状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let opt = this.pestDryingFlap == '关闭' ? '1' : '0';
          let param = {"deviceAddr": this.pestDevice, "module": "dryingFlap", "opt": opt};
          console.log("更改诱虫灯状态", param);
          wormOper(param).then(response => {
            this.pestDryingFlap = this.pestDryingFlap == '关闭' ? '打开' : '关闭';
            this.$message({
              showClose: true,
              type: 'success',
              message: '烘干挡板' + this.pestDryingFlap + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改烘干挡板状态失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改烘干挡板状态已取消'
          })
        })
      },

      /**
       * 更改移虫装置状态
       */
      setMoveWorm() {
        this.$confirm('请确定是否更改移虫装置状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let opt = this.pestMoveWorm == '关闭' ? '1' : '0';
          let param = {"deviceAddr": this.pestDevice, "module": "moveWorm", "opt": opt};
          console.log("更改移虫装置状态", param);
          wormOper(param).then(response => {
            this.pestMoveWorm = this.pestMoveWorm == '关闭' ? '打开' : '关闭';
            this.$message({
              showClose: true,
              type: 'success',
              message: '移虫装置' + this.pestMoveWorm + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改移虫装置状态失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改移虫装置状态已取消'
          })
        })
      },

      /**
       * 拍照
       */
      setCamera() {
        this.$confirm('请确认是否立即进行拍照', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let param = {"deviceAddr": this.pestDevice, "module": "camera", "opt": "1"};
          console.log("拍摄", param);
          wormOper(param).then(response => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '拍摄成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '拍摄失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '取消拍照'
          })
        })
      },

      /**
       * 修改自动模式下的属性
       */
      setWormAutoMode() {
        let param = {"deviceAddr": this.pestDevice, "beginTime": this.pestBeginTime, "runHour": this.pestRunHour,
            "attractWormTime": this.pestAttractWormTime, "insecticideHum": this.pestInsecticideHum, "insecticideHumHystersis": this.pestInsecticideHumHystersis,
            "dryingHum": this.pestDryingHum, "dryingHumHystersis": this.pestDryingHumHystersis, "delayAfterRain": this.pestDelayAfterRain, "openingTimeOfTrapLamp": this.pestOpeningTimeOfTrapLamp};

        modWormAutoMode(param).then(response => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '修改设备自动模式时间成功'
          })
        }).catch(error => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '修改设备自动模式时间失败，请检查格式是否正确'
          })
        })
      }
    }
  }
</script>

<style lang="less">
  @import "../less/PestRealData";
</style>

<style>
  .pestReal-data-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/PestRealData.vue